(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        // Get the base URL and add metafields parameter
        let url = this.dataset.url;

        // In product-recommendations.liquid JavaScript, change:
        if (url.indexOf('?') !== -1) {
          url += '&metafields=air_reviews_product.review_avg,air_reviews_product.review_count';
        } else {
          url += '?metafields=air_reviews_product.review_avg,air_reviews_product.review_count';
        }
        
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

// ===== PHOTOSWIPE INITIALIZATION =====
var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }

  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');

// ===== PURCHASE PANEL VARIANT SYNC =====
document.addEventListener('DOMContentLoaded', function() {
  console.log('Purchase panel sync initialized');
  
  // Get the purchase panel form
  var purchaseForm = document.querySelector('#purchase-panel-form');
  if (!purchaseForm) {
    console.log('Purchase panel form not found');
    return;
  }
  
  // Get variant data from window object (set by Liquid)
  var variantData = window.productVariantData || [];
  console.log('Variant data loaded:', variantData);
  
  // If no variants or only one variant, we don't need to sync
  if (variantData.length <= 1) {
    console.log('Only one variant, no sync needed');
    return;
  }
  
  // Get all purchase panel variant radio buttons
  var variantRadios = document.querySelectorAll('.purchase-panel input[type="radio"]');
  console.log('Found variant radios:', variantRadios.length);
  
  // Get the main variant select dropdown - find by attribute starts with
  var mainVariantSelect = document.querySelector('select[name="id"][class*="product-form__variants"]');
  if (!mainVariantSelect) {
    // Fallback: find by ID pattern
    var allSelects = document.querySelectorAll('select');
    for (var i = 0; i < allSelects.length; i++) {
      if (allSelects[i].id && allSelects[i].id.indexOf('ProductSelect-') === 0) {
        mainVariantSelect = allSelects[i];
        break;
      }
    }
  }
  console.log('Main variant select found:', !!mainVariantSelect);
  
  // Get the main form's option selectors
  var mainOptionSelectors = document.querySelectorAll('.product-form .single-option-selector__radio');
  console.log('Main option selectors found:', mainOptionSelectors.length);
  
  // ===== IMPROVED IMAGE UPDATE FUNCTION =====
  function updateMainImage(variant) {
    console.log('Attempting to update image for variant:', variant);
    
    // Try to find the image from the variant's featured_image
    var imageUrl = null;
    
    if (variant.featured_image) {
      imageUrl = variant.featured_image.src;
      console.log('Found image from variant.featured_image:', imageUrl);
    }
    
    // If no featured_image, try to find by variant options
    if (!imageUrl && variant.options && variant.options.length > 0) {
      console.log('No featured_image, searching by variant options:', variant.options);
      
      // Find all images in the gallery and check their alt text or data
      var allImages = document.querySelectorAll('.photo-image, .product-single__photo');
      for (var i = 0; i < allImages.length; i++) {
        var figure = allImages[i];
        var img = figure.querySelector('img');
        if (img) {
          var alt = img.getAttribute('alt') || '';
          // Check if the alt text contains any of the variant options
          var found = false;
          for (var o = 0; o < variant.options.length; o++) {
            if (alt.toLowerCase().indexOf(variant.options[o].toLowerCase()) !== -1) {
              found = true;
              break;
            }
          }
          if (found) {
            imageUrl = img.getAttribute('src') || img.getAttribute('data-src');
            console.log('Found image by alt text:', imageUrl);
            break;
          }
        }
      }
    }
    
    // If still no image, use the first image in the gallery
    if (!imageUrl) {
      var firstImage = document.querySelector('.photo-image img, .product-single__photo img');
      if (firstImage) {
        imageUrl = firstImage.getAttribute('src') || firstImage.getAttribute('data-src');
        console.log('Using first image as fallback:', imageUrl);
      }
    }
    
    if (!imageUrl) {
      console.log('No image found for this variant');
      return;
    }
    
    // METHOD 1: Find by data-image-id matching
    var imageId = null;
    var allFigures = document.querySelectorAll('.photo-image');
    for (var i = 0; i < allFigures.length; i++) {
      var figure = allFigures[i];
      var img = figure.querySelector('img');
      if (img) {
        var imgSrc = img.getAttribute('src') || img.getAttribute('data-src');
        if (imgSrc && imgSrc.indexOf(imageUrl.split('/').pop()) !== -1) {
          imageId = figure.getAttribute('data-image-id');
          break;
        }
      }
    }
    
    if (imageId) {
      var thumbnail = document.querySelector('.product-single__thumbnail-item[data-image-id="' + imageId + '"]');
      if (thumbnail) {
        var link = thumbnail.querySelector('a');
        if (link) {
          link.click();
          console.log('✅ Image updated via thumbnail click by ID:', imageId);
          return;
        }
      }
    }
    
    // METHOD 2: Find by thumbnail image src matching
    var thumbnails = document.querySelectorAll('.product-single__thumbnail-item, .product-single__thumbnail');
    for (var i = 0; i < thumbnails.length; i++) {
      var thumb = thumbnails[i];
      var img = thumb.querySelector('img');
      if (img) {
        var thumbSrc = img.getAttribute('src') || img.getAttribute('data-src');
        if (thumbSrc && thumbSrc.indexOf(imageUrl.split('/').pop()) !== -1) {
          var link = thumb.querySelector('a');
          if (link) {
            link.click();
            console.log('✅ Image updated via thumbnail match');
            return;
          }
        }
      }
    }
    
    // METHOD 3: Directly update the main image
    var mainImage = document.querySelector('.product-single__photo img, .product__photo-wrapper img, .photos__item--main img');
    if (mainImage) {
      mainImage.src = imageUrl;
      mainImage.srcset = imageUrl;
      if (mainImage.hasAttribute('data-src')) {
        mainImage.setAttribute('data-src', imageUrl);
      }
      if (mainImage.hasAttribute('data-srcset')) {
        mainImage.setAttribute('data-srcset', imageUrl);
      }
      // Update parent link
      var parentLink = mainImage.closest('a');
      if (parentLink) {
        parentLink.href = imageUrl;
        parentLink.setAttribute('data-size', '1400x1400');
      }
      console.log('✅ Image updated directly');
    }
    
    // METHOD 4: Update all product images in the gallery
    var productSection = document.querySelector('.photos__item--main, .product-single__photo');
    if (productSection) {
      var images = productSection.querySelectorAll('img');
      for (var i = 0; i < images.length; i++) {
        var img = images[i];
        if (img.src && img.src.indexOf('cdn.shopify.com') !== -1) {
          img.src = imageUrl;
          img.srcset = imageUrl;
          if (img.hasAttribute('data-src')) {
            img.setAttribute('data-src', imageUrl);
          }
        }
      }
      console.log('✅ All gallery images updated');
    }
  }
  
  // Function to update the purchase panel based on selected variant
  function updatePurchasePanelFromVariant(variantId) {
    if (!variantId) return;
    
    // Find the matching variant
    var matchedVariant = null;
    for (var i = 0; i < variantData.length; i++) {
      if (variantData[i].id === parseInt(variantId)) {
        matchedVariant = variantData[i];
        break;
      }
    }
    
    if (!matchedVariant) {
      console.log('Variant not found:', variantId);
      return;
    }
    
    console.log('Updating purchase panel for variant:', matchedVariant.title);
    
    // Update hidden input
    var hiddenInput = purchaseForm.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = matchedVariant.id;
    }
    
    // Update price
    var priceElement = document.querySelector('.purchase-panel .product-single__price');
    if (priceElement && matchedVariant.price !== undefined) {
      var price = matchedVariant.price / 100;
      priceElement.textContent = '$' + price.toFixed(2);
    }
    
    // Update compare price
    var comparePriceElement = document.querySelector('.purchase-panel .product-single__price--compare');
    if (comparePriceElement) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > 0) {
        var comparePrice = matchedVariant.compare_at_price / 100;
        comparePriceElement.textContent = '$' + comparePrice.toFixed(2);
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
    
    // Update sale tag
    var saleTag = document.querySelector('.purchase-panel .product-tag-sale');
    if (saleTag) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        var salePercent = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
        saleTag.textContent = 'SALE -' + salePercent + '%';
        saleTag.style.display = 'inline-block';
      } else {
        saleTag.style.display = 'none';
      }
    }
    
    // Update Add to Cart button
    var addToCartBtn = purchaseForm.querySelector('button[type="submit"]');
    if (addToCartBtn) {
      if (matchedVariant.available) {
        addToCartBtn.innerHTML = 'Add to Cart';
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.innerHTML = 'Sold Out';
        addToCartBtn.disabled = true;
      }
    }
    
    // ===== UPDATE MAIN PRODUCT IMAGE =====
    updateMainImage(matchedVariant);
    
    // Update radio buttons in purchase panel
    var purchaseRadios = document.querySelectorAll('.purchase-panel input[type="radio"]');
    for (var i = 0; i < purchaseRadios.length; i++) {
      var radio = purchaseRadios[i];
      var label = radio.closest('label');
      if (label) {
        // Check if this radio's value matches the variant's option
        var optionIndex = parseInt(radio.getAttribute('data-option-index') || 0);
        if (matchedVariant.options && matchedVariant.options[optionIndex] === radio.value) {
          radio.checked = true;
          label.classList.add('selected');
        } else {
          label.classList.remove('selected');
        }
      }
    }
  }
  
  // Listen for changes on main variant select
  if (mainVariantSelect) {
    mainVariantSelect.addEventListener('change', function() {
      var variantId = parseInt(this.value);
      updatePurchasePanelFromVariant(variantId);
    });
  }
  
  // Listen for changes on main option radios
  for (var i = 0; i < mainOptionSelectors.length; i++) {
    var radio = mainOptionSelectors[i];
    radio.addEventListener('change', function() {
      // Find the selected options
      var selectedOptions = [];
      var checkedRadios = document.querySelectorAll('.product-form .single-option-selector__radio:checked');
      for (var j = 0; j < checkedRadios.length; j++) {
        selectedOptions.push(checkedRadios[j].value);
      }
      
      // Find matching variant
      if (selectedOptions.length > 0 && variantData.length > 0) {
        var matchedVariant = null;
        for (var k = 0; k < variantData.length; k++) {
          var v = variantData[k];
          var allMatch = true;
          for (var o = 0; o < v.options.length; o++) {
            if (v.options[o] !== selectedOptions[o]) {
              allMatch = false;
              break;
            }
          }
          if (allMatch) {
            matchedVariant = v;
            break;
          }
        }
        
        if (matchedVariant && mainVariantSelect) {
          mainVariantSelect.value = matchedVariant.id;
          mainVariantSelect.dispatchEvent(new Event('change'));
          updatePurchasePanelFromVariant(matchedVariant.id);
        }
      }
    });
  }
  
  // Listen for changes on purchase panel radio buttons
  for (var i = 0; i < variantRadios.length; i++) {
    var radio = variantRadios[i];
    radio.addEventListener('change', function() {
      // Get all selected values from purchase panel
      var selectedValues = [];
      var wrappers = document.querySelectorAll('.purchase-panel .selector-wrapper');
      for (var j = 0; j < wrappers.length; j++) {
        var selected = wrappers[j].querySelector('input[type="radio"]:checked');
        if (selected) {
          selectedValues.push(selected.value);
        }
      }
      
      console.log('Purchase panel selected values:', selectedValues);
      
      // Find matching variant
      if (selectedValues.length > 0 && variantData.length > 0) {
        var matchedVariant = null;
        for (var k = 0; k < variantData.length; k++) {
          var v = variantData[k];
          var allMatch = true;
          for (var o = 0; o < v.options.length; o++) {
            if (v.options[o] !== selectedValues[o]) {
              allMatch = false;
              break;
            }
          }
          if (allMatch) {
            matchedVariant = v;
            break;
          }
        }
        
        if (matchedVariant) {
          console.log('Matched variant from purchase panel:', matchedVariant.title);
          
          // Update main form select
          if (mainVariantSelect) {
            mainVariantSelect.value = matchedVariant.id;
            mainVariantSelect.dispatchEvent(new Event('change'));
          }
          
          // Update main form radio buttons
          for (var r = 0; r < mainOptionSelectors.length; r++) {
            var radioEl = mainOptionSelectors[r];
            var optionIndex = parseInt(radioEl.getAttribute('data-index') || 0);
            if (matchedVariant.options && matchedVariant.options[optionIndex] === radioEl.value) {
              radioEl.checked = true;
              radioEl.dispatchEvent(new Event('change'));
            }
          }
          
          // Update purchase panel
          updatePurchasePanelFromVariant(matchedVariant.id);
        }
      }
    });
  }
  
  // Initialize with current variant
  if (mainVariantSelect) {
    var initialVariantId = parseInt(mainVariantSelect.value);
    if (initialVariantId) {
      updatePurchasePanelFromVariant(initialVariantId);
    }
  }
  
  // Handle Add to Cart click
  var purchaseAddToCart = purchaseForm.querySelector('button[type="submit"]');
  if (purchaseAddToCart) {
    purchaseAddToCart.addEventListener('click', function(e) {
      e.preventDefault();
      
      var variantIdInput = purchaseForm.querySelector('input[name="id"]');
      var variantId = variantIdInput ? variantIdInput.value : null;
      var quantityInput = purchaseForm.querySelector('input[name="quantity"]');
      var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId),
          quantity: quantity
        })
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        if (data) {
          fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
              var cartCount = document.querySelector('.js-cart-count');
              if (cartCount) {
                cartCount.textContent = cart.item_count;
              }
              
              var btn = purchaseAddToCart;
              var originalText = btn.innerHTML;
              btn.innerHTML = '✓ Added!';
              btn.style.background = '#2e7d32';
              setTimeout(function() {
                btn.innerHTML = originalText;
                btn.style.background = '';
              }, 2000);
            })
            .catch(function(err) {
              console.error('Error fetching cart:', err);
            });
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        purchaseForm.submit();
      });
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
